export const CheckboxLabelSize = {
  SMALL: 'small',
  NORMAL: 'normal'
};
export const CHECKBOX_ADDITIONAL_HIT_AREA = 20;